import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
// @ is an alias to /src
import { fetchPosts } from '@/services/userService';

@Component
export default class SidenaviNewentries extends Vue {
  private　name = 'sidenavinewentries';
  private list: PostData[] = [];
  @Prop()
  private label!: string;
  @Emit()
  private setList(list: PostData[]) {
    this.list = list;
  }
  @Emit()
  private async getNewEntries(params: {cat: string; length: number;}) {
    const result = await fetchPosts(params)
    .then( (response) => {
      this.setList(response.datas);
      return true;
    })
    .catch( (e) => {
      console.error(e);
      return false;
    });
    return result;
  }
  @Emit()
  private linkUrl(id: string): string {
    const path: string[] = this.$route.fullPath.split('/');
    path[path.length - 1] = id;
    return path.join('/');
  }
}
